import googleLogo from '@/assets/images/pngs/Google-logo.png';
import { t } from 'i18next';
import { ENV_CLIENT_ID } from '@/configs/environment';
import { STATE_AUTH_PARAMS } from '@/configs/constants';

interface GoogleButtonProps {
    state: string
}

const GoogleButton = ({ state }: GoogleButtonProps) => {
    const handleLogin = () => {
        const scope = 'email';
        const responseType = 'code';
        const prompt = 'consent';
        const url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${ENV_CLIENT_ID.googleClientId}&redirect_uri=${ENV_CLIENT_ID.redirectUrl}&response_type=${responseType}&scope=${scope}&prompt=${prompt}&state=${state}`; // Thêm action vào URL
        window.location.href = url;
    };
    return (

        <div onClick={handleLogin} className='w-full h-[48px] rounded-full border-borderGray border-[1px] flex justify-center items-center cursor-pointer content-center py-[12px]'>
            <img src={googleLogo} alt='googleLogo' className='w-[24px] h-[24px]' />
            <p className='ml-[10px] text-[15px] text-text font-semibold'>{t('text.viaGoogle')}</p>
        </div>
    );
};

export default GoogleButton;
